import { Button, Form, Modal, Select } from "antd";
import React from 'react';
import MaskedInput from "react-input-mask";
import { useDispatch, useSelector } from 'react-redux';
import { SpecialCharacters } from "../../Constants/DataModelToolConstants";
import { actionViewerSliceDispatch, apiResponseModalSliceDispatch, pickAFileSliceDispatch, questionViewerSliceDispatch, refreshLoadedFileSliceDispatch, ruleViewerSliceDispatch, selectFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import UploadFileService from "../../Services/UploadFileService";

function ServiceModal() {
    const selectedFilesList = useSelector((state: any) => state.selectFile.selectedFilesList);
    const selectedFileTemplate = useSelector((state: any) => state.selectFile.selectedFileTemplate);

    const isTemplate = useSelector((state: any) => state.selectFile.isTemplate);
    const isDataModel = useSelector((state: any) => state.selectFile.isDataModel);

    const addressStart = useSelector((state: any) => state.pickAFile.addressStart);
    const addressEnd = useSelector((state: any) => state.pickAFile.addressEnd);

    const open = useSelector((state: any) => state.selectFile.open);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    const templateDropDownList = selectedFilesList.map((x: any) => {
        return {
            key: x,
            text: x,
            value: x
        }
    })

    const onCancel = () => {
        dispatch({ type: selectFileSliceDispatch.setOpen, payload: false })
    }

    const onTemplateDropDownChange = (event: string) => {
        dispatch({ type: selectFileSliceDispatch.setSelectedFileTemplate, payload: event })
    }

    const onAddressStartChange = (event: { target: { value: any; }; }) => {
        dispatch({ type: pickAFileSliceDispatch.setAddressStart, payload: event.target.value })
    }

    const onAddressEndChange = (event: { target: { value: any; }; }) => {
        dispatch({ type: pickAFileSliceDispatch.setAddressEnd, payload: event.target.value })
    }

    async function DownloadFileClick() {
        dispatch({ type: refreshLoadedFileSliceDispatch.setIsLoading, payload: true });

        let isApiCallSuccessful: boolean = false;
        let values: string = "";
        let fileName: string = selectedFileTemplate

        if (isTemplate) {
            await UploadFileService.getTemplateFileContents(fileName)
                .then(response => {
                    if (response.status == 200) {
                        isApiCallSuccessful = true;

                        values = JSON.stringify(response.data);
                    }
                    else {
                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: response.data })
                    }
                })
                .catch((e) => {
                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: e.message })
                });;
        }

        if (isDataModel) {
            await UploadFileService.getFileContents(fileName)
                .then(response => {
                    if (response.status == 200) {
                        isApiCallSuccessful = true;

                        values = JSON.stringify(response.data);
                    }
                    else {
                        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                        dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: response.data })
                    }
                })
                .catch((e) => {
                    dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: true })
                    dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: e.message })
                });;
        }

        if (isApiCallSuccessful) {
            let questions = JSON.parse(values)["questions"]
            const duplicateDataKeys = questions.map((x: { dataKey: any; }) => x.dataKey).filter((item: any, index: any) => questions.map((y: { dataKey: any; }) => y.dataKey).indexOf(item) !== index)

            let specialCharacters = questions.filter((item: any) => SpecialCharacters.some(y => item.dataKey.includes(y))).map((z: { dataKey: any; }) => z.dataKey);

            let rules = JSON.parse(values)["rules"]
            const duplicateRuleEventTypes = rules.map((x: { event: any; }) => x.event).map((x: { type: any; }) => x.type).filter((item: any, index: any) => rules.map((y: { event: any; }) => y.event).map((y: { type: any; }) => y.type).indexOf(item) !== index)

            if (specialCharacters?.length > 0) {
                alert("Unable to download file from Azure due to corrupted data caused by special characters in the data names for the questions. The following popup data keys are include special characters.")
                specialCharacters.forEach((specialCharacter: any) => alert(specialCharacter))
            }
            else if (duplicateDataKeys?.length > 0) {
                alert("Unable to download file from Azure due to corrupted data caused by duplicate data keys for the questions. The following popup data keys are duplicates.")
                duplicateDataKeys.forEach((dup: any) => alert(dup))
            }
            else if (duplicateRuleEventTypes?.length > 0) {
                alert("There are duplicate event types for the rules. Please select the 'Close File Without Saving' button. The following popup event types are duplicates.")
                duplicateRuleEventTypes.forEach((dup: any) => alert(dup))
            }
            else {
                var parsedValues = JSON.parse(values)
                dispatch({ type: pickAFileSliceDispatch.setQuestions, payload: questions })
                dispatch({ type: questionViewerSliceDispatch.setQuestionSearchResults, payload: questions })

                dispatch({ type: pickAFileSliceDispatch.setFileLength, payload: values.length })

                dispatch({ type: pickAFileSliceDispatch.setFileContents, payload: values })

                dispatch({ type: pickAFileSliceDispatch.setFileName, payload: fileName })

                dispatch({ type: pickAFileSliceDispatch.setActions, payload: parsedValues.actions })
                dispatch({ type: actionViewerSliceDispatch.setActionSearchResults, payload: parsedValues.actions })

                if (isDataModel) {
                    dispatch({ type: pickAFileSliceDispatch.setAddressStart, payload: parsedValues.addressStart })

                    dispatch({ type: pickAFileSliceDispatch.setAddressEnd, payload: parsedValues.addressEnd })
                }

                dispatch({ type: pickAFileSliceDispatch.setAssistanceFormId, payload: parsedValues.assistanceFormId })

                dispatch({ type: pickAFileSliceDispatch.setBaseName, payload: parsedValues.baseName })

                dispatch({ type: pickAFileSliceDispatch.setBusinessRules, payload: parsedValues.businessRules })

                dispatch({ type: pickAFileSliceDispatch.setBrandList, payload: parsedValues.brandList })

                dispatch({ type: pickAFileSliceDispatch.setFormDescription, payload: parsedValues.formDescription })

                dispatch({ type: pickAFileSliceDispatch.setFormName, payload: parsedValues.formName })

                dispatch({ type: pickAFileSliceDispatch.setFormRuleSetId, payload: parsedValues.formRuleSetId })

                dispatch({ type: pickAFileSliceDispatch.setInterfaceId, payload: parsedValues.interfaceId })

                dispatch({ type: pickAFileSliceDispatch.setLayout, payload: parsedValues.layout })

                dispatch({ type: pickAFileSliceDispatch.setRules, payload: parsedValues.rules })
                dispatch({ type: ruleViewerSliceDispatch.setRuleSearchResults, payload: rules })

                dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: parsedValues.serviceBrandQuestions })

                dispatch({ type: pickAFileSliceDispatch.setServiceList, payload: parsedValues.serviceList })

                dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: parsedValues.serviceQuestions })

                let tempBrandDropDownList = parsedValues.brandList.map((b: { brandId: any; brandName: any; }) => {
                    return ({ key: b.brandId, label: b.brandName, value: b.brandId })
                })

                dispatch({ type: pickAFileSliceDispatch.setBrandDropDownList, payload: tempBrandDropDownList })

                let tempServiceDropDownList = parsedValues.serviceList.map((b: { serviceId: any; serviceName: any; }) => {
                    return ({ key: b.serviceId, label: b.serviceName, value: b.serviceId })
                })

                dispatch({ type: pickAFileSliceDispatch.setServiceDropDownList, payload: tempServiceDropDownList })

                dispatch({ type: pickAFileSliceDispatch.setHasMultipleServices, payload: tempServiceDropDownList.length > 1 })
                dispatch({ type: pickAFileSliceDispatch.setHasMultipleBrands, payload: tempBrandDropDownList.length > 1 })

                dispatch({ type: apiResponseModalSliceDispatch.setOpenedFileFromApi, payload: true })

                CreateContentsFromStates(parsedValues)
            }

            dispatch({ type: selectFileSliceDispatch.setOpen, payload: false })
            dispatch({ type: refreshLoadedFileSliceDispatch.setIsLoading, payload: false });
        }
    }

    return (
        <Modal
            title="Service Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}
        >
            <Form
                onFinish={DownloadFileClick}
                preserve={false}
            >
                <Form.Item rules={[{ required: true }]} name="Template" label="Template">
                    <Select
                        placeholder='Select Template'
                        options={templateDropDownList}
                        onChange={onTemplateDropDownChange}
                        id="selectTemplate"
                    />
                </Form.Item>
                {(isTemplate && !isDataModel) &&
                    <div>
                        <Form.Item rules={[{ required: true }]} name="Address Start" label="Address Start">
                            <MaskedInput
                                className="ant-input"
                                mask="99\000"
                                maskChar=" "
                                onChange={onAddressStartChange}
                                placeholder='Address Start'
                                id="addressStart"
                            />
                        </Form.Item>
                        <Form.Item rules={[{ required: true }]} name="Address End" label="Address End">
                            <MaskedInput
                                className="ant-input"
                                mask="99999"
                                maskChar=" "
                                onChange={onAddressEndChange}
                                placeholder='Address End'
                                id="addressEnd"
                            />
                        </Form.Item>
                    </div>
                }
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default ServiceModal;